import useWebChatAPIContext from '/druid/useWebChatAPIContext';

export default function useMarkActivity() {
  return useWebChatAPIContext().markActivity;
}
